import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = ({ userName, currentTime }) => {
  const getGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  const formatDate = () => {
    return new Date()?.toLocaleDateString('en-GB', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-primary rounded-lg p-6 text-primary-foreground mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold mb-2">
            {getGreeting()} {userName}!
          </h1>
          <p className="text-primary-foreground/80 mb-1">
            Ready to plan your next adventure?
          </p>
          <div className="flex items-center space-x-2 text-sm text-primary-foreground/70">
            <Icon name="Calendar" size={14} />
            <span>{formatDate()}</span>
          </div>
        </div>
        
        <div className="hidden md:flex items-center space-x-4">
          <div className="text-right">
            <div className="text-sm text-primary-foreground/70">Your Journey Starts</div>
            <div className="text-lg font-semibold">Here & Now</div>
          </div>
          <div className="w-16 h-16 bg-primary-foreground/10 rounded-full flex items-center justify-center">
            <Icon name="Plane" size={24} className="text-primary-foreground" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;